import React from "react";
import Icon from "./components/icons";
import './artemis-panel.scss'

// "Ask Artemis" over the bottom-left of the map while the left toolbar is closed (Basemap Home v2):
// opens the Artemis side panel, the same as the icon bar's Artemis button.
const ArtemisLauncher = ({ onOpen }) => (
  <button type="button" className="artemis-launcher" onClick={onOpen}>
    <Icon name="sparkle" size={18} />
    Ask Artemis
  </button>
)

export default ArtemisLauncher
